import {Button} from '@/components/ui/button/Button'
import {Modal, ModalFooter, ModalOverlay} from '@/components/ui/modal-atoms/ModalAtoms'
import {useTranslation} from '@/translations/i18n'
import {TreatmentRequestExtended} from '@/features/treatment-requests/types'
import {TreatmentRequestFollowUps} from '@/features/treatment-requests/components/treatment-request-follow-ups/TreatmentRequestFollowUps'
import {
    StyledFollowUpModalButton,
    StyledTreatmentRequestFollowUpModalBody,
    StyledTreatmentRequestFollowUpModalHeader,
    StyledTreatmentRequestFollowUpModalSubtitle,
    StyledTreatmentRequestFollowUpModalTitle
} from './style'
import {useToggle} from '@/hooks/useToggle'
import {formatDate} from '@/dayjs'

export const TreatmentRequestFollowUpModal = ({
    followUps,
    expirationDate,
    isReadOnly
}: {
    followUps: TreatmentRequestExtended['followups']
    expirationDate: NonNullable<TreatmentRequestExtended['expirationDate']>
    isReadOnly?: boolean
}) => {
    const {t} = useTranslation()
    const {isActive: isModalVisible, off: closeModal, on: openModal} = useToggle()

    return (
        <>
            <StyledFollowUpModalButton
                $isReadOnly={isReadOnly}
                size="sm"
                fullWidth={false}
                variant="secondary"
                onClick={isReadOnly ? undefined : openModal}
            >
                {followUps.length > 0
                    ? t('treatment_requests:last_follow_up_date', {date: formatDate(followUps[0].date, 'DD/MM/YYYY')})
                    : t('treatment_requests:no_follow_up')}
            </StyledFollowUpModalButton>
            {isModalVisible && (
                <>
                    <ModalOverlay onClick={closeModal} />
                    <Modal width="400px" overflowY="unset">
                        <StyledTreatmentRequestFollowUpModalHeader>
                            <StyledTreatmentRequestFollowUpModalTitle>
                                {t('treatment_requests:follow_up', {count: 2})}
                            </StyledTreatmentRequestFollowUpModalTitle>
                            <StyledTreatmentRequestFollowUpModalSubtitle>
                                {t('treatment_requests:request_expiration_date', {
                                    date: formatDate(expirationDate, 'DD/MM/YYYY')
                                })}
                            </StyledTreatmentRequestFollowUpModalSubtitle>
                        </StyledTreatmentRequestFollowUpModalHeader>

                        <StyledTreatmentRequestFollowUpModalBody>
                            <TreatmentRequestFollowUps followUps={followUps} />
                        </StyledTreatmentRequestFollowUpModalBody>

                        <ModalFooter>
                            <Button variant="secondary" onClick={closeModal}>
                                {t('commons:close')}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </>
            )}
        </>
    )
}
